import { createFileRoute } from '@tanstack/react-router'

import PointsPage from '@/views/loyalty/points/pages/points.page'

export const Route = createFileRoute('/phong-nha/loyalty/points')({
  component: PointsPage,
})
